import React, { useEffect, useState } from 'react'
import PageContainer from 'srcReact/PageContainer/PageContainer'
import styles from './styles.module.scss'
import { useTranslation } from 'react-i18next'
import BasicInfo from './components/BasicInfo'
import MixrVenue from './components/MixrVenue'
import MixrTiming from './components/MixrTiming'
import MixrInterests from './components/MixrInterests'
import InviteMembers from './components/InviteMembers'
import Button from 'srcReact/components/common2/Button'
import MixrPicture from './components/MixrPicture'
import { useSelector, useDispatch } from 'react-redux'
import { mixrActions } from 'srcReact/Mixr/actions'
import { commonActions } from 'srcReact/components'
import { isPastDate } from 'srcReact/helpers/datetimeHelper'
import Loader from 'srcReact/components/common2/Loader'
import Popup from 'reactjs-popup'
import Icon from 'srcReact/components/icons/Icon'
import { decode } from 'html-entities/lib/index'
import Modal from 'srcReact/components/common2/Modal'
import Link from 'react-router-dom/Link'
import { redirectToPage } from 'srcReact/helpers/history'
import colorVariables from 'srcReact/assets/scss/global/base/_variables.scss'
import { alertActions, AlertContainer } from 'srcReact/Alert'
import EditMixrPopup from './components/EditMixrPopup'

export default function UpdateMixR(props) {
  const { fromGroupId, fromGroup } = props
  const { t } = useTranslation()
  const [showLoader, setShowLoader] = useState(false)

  const [showEditMixrPopup, setShowEditMixrPopup] = useState(false)
  const [dataToUpdateForRecMixr, setDataToUpdateForRecMixr] = useState(null)
  const dispatch = useDispatch()
  const {
    alert,
    common: { groupsByOrgId, isNative, isTablet },
    mixr: { mixr },
    mixr: {
      mixr: { id, name, group: selectedGroup, recurrence, local_invite_send_date, is_invite_scheduled },
      createUpdateErrors,
      editLoading,
      editSuccess
    }
  } = useSelector((state) => state)

  useEffect(() => {
    return () => {
      dispatch(commonActions.fileCreationRemove())
      dispatch(commonActions.updateSelectedInterests([]))
      dispatch(mixrActions.clearCreatedMixrValues())
    }
  }, [])

  useEffect(() => {
    if (selectedGroup) {
      if (selectedGroup.can_plan_mixr && selectedGroup.can_plan_mixr.toString() === '1') {
        dispatch(mixrActions.setMixrData([{ key: 'createMixrType', value: 'plan' }]))
      } else if (selectedGroup.can_suggest_mixr && selectedGroup.can_suggest_mixr.toString() === '1') {
        dispatch(mixrActions.setMixrData([{ key: 'createMixrType', value: 'suggest' }]))
      } else {
        dispatch(mixrActions.setMixrData([{ key: 'createMixrType', value: '' }]))
      }
    }
  }, [selectedGroup])

  const closeLoaderModal = () => {
    setShowLoader(false)
  }

  const openEditMixrPopup = () => {
    dispatch(mixrActions.resetEditSuccessFlag())
    setShowEditMixrPopup(true)
  }

  const closeEditMixrPopup = () => {
    setShowEditMixrPopup(false)
  }

  useEffect(() => {
    if (groupsByOrgId && groupsByOrgId.list.length > 0) {
      if (selectedGroup) {
        const groupObj = groupsByOrgId.list.find(
          (g) => g.group_id === selectedGroup.id || g.group_id === selectedGroup.group_id
        )
        dispatch(mixrActions.setMixrData([{ key: 'group', value: groupObj }]))
      }
    }
  }, [groupsByOrgId, selectedGroup])

  useEffect(() => {
    if (createUpdateErrors && createUpdateErrors.length > 0) {
      setShowLoader(false)
    }
  }, [createUpdateErrors])

  return (
    <PageContainer pageClassName={styles.pageContainer} pageTitle={t('event.create.pageTitleEdit')} withFooter={false}>
      {alert && alert.message ? (
        <AlertContainer
          title={t('error.error_alert_title')}
          message={alert.message}
          show={!!alert.message}
          handleClose={() => dispatch(alertActions.clear())}
        />
      ) : null}
      {fromGroup && fromGroup.group_id > 0 && (
        <div className={styles.headerContainer}>
          <Link className={styles.backUrl} to={`/0/home/group/${fromGroup.group_id}`}>
            <Icon styleModifier={styles.backIcon} name='arrow-left24' />
            <span>{decode(fromGroup.group_name)}</span>
          </Link>
        </div>
      )}
      {mixr && (
        <div className={styles.headerContainer}>
          <Link className={styles.backUrl} to={`/0/home/event/${id}`}>
            <Icon styleModifier={styles.backIcon} name='arrow-left24' />
            <span>{decode(name)}</span>
          </Link>
        </div>
      )}

      <form className={`${styles.container} ${fromGroupId > 0 && styles.containerWithMarginTop}`}>
        <h1 className={styles.title}>{t('event.create.pageTitleEdit')}</h1>
        <div className={`${styles.outerContainer} ${styles.firstOuterContainer} `}>
          <div className={styles.innerContainer}>
            <BasicInfo
              editMode={true}
              fromGroupId={fromGroupId}
              allGroups={groupsByOrgId ? groupsByOrgId.list : []}
              openEditMixrPopup={openEditMixrPopup}
              setDataToUpdateForRecMixr={setDataToUpdateForRecMixr}
            />
          </div>
        </div>

        <div className={`${styles.outerContainer} `}>
          <div className={styles.verticalLine}></div>
          <div className={`${styles.innerContainer} ${styles.innerContainerImgCropper}`}>
            <MixrPicture
              editMode={true}
              openEditMixrPopup={openEditMixrPopup}
              setDataToUpdateForRecMixr={setDataToUpdateForRecMixr}
            />
          </div>
        </div>

        <div className={`${styles.outerContainer} `}>
          <div className={styles.innerContainer}>
            <MixrVenue
              editMode={true}
              openEditMixrPopup={openEditMixrPopup}
              setDataToUpdateForRecMixr={setDataToUpdateForRecMixr}
            />
          </div>
          <div className={styles.verticalLine}></div>
        </div>
        {/* Do not show mixr timing section is mixr is a parent mixr */}
        {recurrence?.is_parent_event === 0 && (
          <div className={`${styles.outerContainer} `}>
            <div className={`${styles.innerContainer} ${styles.innerContainerTiming}`}>
              <MixrTiming
                editMode={true}
                openEditMixrPopup={openEditMixrPopup}
                setDataToUpdateForRecMixr={setDataToUpdateForRecMixr}
              />
            </div>
            <div className={styles.verticalLine}></div>
          </div>
        )}

        <div className={`${styles.outerContainer}`}>
          <div className={styles.innerContainer}>
            <MixrInterests
              editMode={true}
              groupInterests={selectedGroup && selectedGroup.interests}
              openEditMixrPopup={openEditMixrPopup}
              setDataToUpdateForRecMixr={setDataToUpdateForRecMixr}
            />
          </div>
          <div className={styles.verticalLine}></div>
        </div>

        {mixr && !isPastDate(local_invite_send_date, 'string') && is_invite_scheduled === 1 ? (
          <div className={styles.outerContainer}>
            <div className={styles.innerContainer}>
              <InviteMembers editMode={true} inviteDateToUpdate={local_invite_send_date} />
            </div>
            <div className={styles.verticalLine}></div>
          </div>
        ) : null}
        {mixr && (
          <Button
            customStyle={styles.doneButton}
            size='large'
            text={t('global.done')}
            handleClick={() => {
              redirectToPage(`/0/home/event/${id}`, isNative)
            }}
          />
        )}
      </form>
      {showLoader && (
        <Popup
          nested
          contentStyle={{ background: colorVariables.whiteBG, border: '0', width: '100vw', height: '100vh' }}
          overlayStyle={{ background: 'rgba(46, 45, 45, 0.7)', backdropFilter: 'blur(7px)', zIndex: 1040 }}
          open={showLoader}
          onClose={closeLoaderModal}
          closeOnDocumentClick={false}
          closeOnEscape={false}>
          <Loader title={t('event.create.updatingMixrLoader', { mixrName: mixrName })} closeModal={closeLoaderModal} />
        </Popup>
      )}

      {showEditMixrPopup && mixr && (
        <Modal isOpen={showEditMixrPopup} handleClose={closeEditMixrPopup}>
          <EditMixrPopup
            loading={editLoading}
            dataToUpdateForRecMixr={dataToUpdateForRecMixr}
            editSuccess={editSuccess}
            mixrId={id}
            isRecurrentMixr={recurrence && recurrence.type && recurrence.type !== 'none'}
            closeModal={closeEditMixrPopup}
          />
        </Modal>
      )}
    </PageContainer>
  )
}
